import React from "react";
import Select from "react-select";

const CustomSelect = props => {
  const {
    getOptionLabel,
    isMulti,
    options,
    value,
    isDisabled,
    ...otherProps
  } = props;
  return (
    <Select
      getOptionLabel={getOptionLabel}
      getOptionValue={({ id }) => id}
      value={value}
      options={options}
      isMulti={isMulti}
      isDisabled={isDisabled}
      onChange={option => props._handleChangeInSelect(option)}
      {...otherProps}
      // onBlur={option => props.onBlur(option)}
      // blurInputOnSelect={option => props.onBlur(option)}
      data-test="customselect-select"
    />
  );
};
export default CustomSelect;



// WEBPACK FOOTER //
// ./src/commonComponents/CustomSelect/CustomSelect.js